module.exports = __webpack_public_path__ + "08_face.5a3f5a27.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer1/08_face.png
// module id = ElSP
// module chunks = 0